import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth';

interface Props {
  children: ReactNode;
  /** Redirect target when not authenticated. */
  redirectTo?: string;
}

export function RequireAuth({ children, redirectTo = '/connexion' }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-soft">
        <div className="animate-pulse">Chargement…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
